<template>
  <BasicButton
    @click="togglefavourite"
    :title="favouriteState ? 'Убрать из избранного' : 'Добавить в избранное'"
    appearance="icon-only"
  >
    <SvgIcon
      icon="favorite"
      size="24"
      :source="$options.icons"
      class="response-favourite-button__icon"
      :class="favouriteState ? 'response-favourite-button__icon--active' : ''"
    />
  </BasicButton>
</template>

<script>
import { VacanciesResponsesFavouriteResource } from 'src/services/vacancies.js';

import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

export default {
  name: 'ResponseFavouriteButton',

  icons: '/images/responses-v3.svg',

  components: {
    SvgIcon,
    BasicButton,
  },

  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
    responseId: {
      type: Number,
      required: true,
    },
    favourite: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['unfavouriteResponse', 'favouriteResponse'],

  data() {
    return {
      favouriteState: this.favourite,
    };
  },

  methods: {
    responsesFavouritePost: VacanciesResponsesFavouriteResource.post,
    responsesFavouriteDelete: VacanciesResponsesFavouriteResource.delete,

    togglefavourite() {
      if (this.favouriteState) {
        this.responsesFavouriteDelete({
          vacancyId: this.vacancyId,
          responseId: this.responseId,
        });
        this.favouriteState = false;
        this.$emit('unfavouriteResponse', { responseId: this.responseId });
      } else {
        this.responsesFavouritePost({
          vacancyId: this.vacancyId,
          responseId: this.responseId,
        });
        this.favouriteState = true;
        this.$emit('favouriteResponse', { responseId: this.responseId });
      }
    },
  },
};
</script>
